module.exports = false;



//////////////////
// WEBPACK FOOTER
// F:/node/angular/complejidadesFrontend/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1